import {ONE_TIME, RECURRING} from "../Constants/PaymentTypes";
import {useController} from "react-hook-form";
import RadioGroup from "./RadioGroup";
import {useTranslation} from "react-i18next";

const PaymentTypeSwitch = ({control, name, onChangePaymentType}) => {
    const {
        field: {onChange, onBlur, value},
    } = useController({
        name,
        control,
        rules: {required: false},
    })
    const {t} = useTranslation('common');
    const types = [ONE_TIME, RECURRING].map(id => {
        return {id, label: t(id.toLowerCase())}
    });
    return (
        <div>
            <RadioGroup
                onChange={e => {
                    onChange(e);
                    onChangePaymentType(e.target.value)
                }}
                onBlur={onBlur}
                value={value}
                items={types}/>

        </div>
    )
}

export default PaymentTypeSwitch;
